<li class="gw-action-item-label">
    <slot />
</li>

<style>
    .gw-action-item-label {
        border-top: 1px solid #f4f5f6;
        border-bottom: 1px solid #f4f5f6;
        padding: 8px 8px;
        color: var(--gw-dark-text-color);
        font-size: 10px;
        color: #777e90;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        appearance: none;
        margin: 8px -8px 8px -8px;

        &:first-child {
            margin-top: 0;
            border-top: 0;
        }
    }
</style>
